import React from 'react';
export function VideosSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-12" data-id="element-3481">
      <div className="text-center space-y-6" data-id="element-3482">
        <h3 className="text-2xl font-bold text-navy" data-id="element-3483">
          Bodor Laser - 3000w, 6000w and 12000w Fiber Laser Cutting Comparison
        </h3>
        <div className="aspect-video w-full max-w-3xl mx-auto rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3484">
          <iframe className="w-full h-full" src="https://www.youtube.com/embed/qnnTjMWWnqc?wmode=opaque" title="Bodor Laser Cutting Comparison" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3485"></iframe>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8 pt-8 border-t border-gray-100" data-id="element-3486">
        <div className="text-center space-y-6" data-id="element-3487">
          <h3 className="text-xl font-bold text-navy" data-id="element-3488">
            Bodor Laser 40kW Fiber Laser
          </h3>
          <div className="aspect-video w-full rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3489">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/tjLo3vzLHo8?wmode=opaque" title="Bodor Laser 40kW Fiber Laser" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3490"></iframe>
          </div>
        </div>

        <div className="text-center space-y-6" data-id="element-3491">
          <h3 className="text-xl font-bold text-navy" data-id="element-3492">
            Bodor Laser 12kW Fiber Laser Cutting 12mm Carbon Steel
          </h3>
          <div className="aspect-video w-full rounded-lg overflow-hidden shadow-sm border border-gray-200" data-id="element-3493">
            <iframe className="w-full h-full" src="https://www.youtube.com/embed/rTUoPaF4wGg?wmode=opaque" title="Bodor Laser 12kW Fiber Laser Cutting" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-3494"></iframe>
          </div>
        </div>
      </div>
    </div>;
}